"use strict";
// The comment above is intented
// More details here https://www.typescriptlang.org/docs/handbook/triple-slash-directives.html
/// <reference types="@types/gtag.js" />
Object.defineProperty(exports, "__esModule", { value: true });
